import gql from 'graphql-tag';

export const mutationCreateOAuthProviderCode = gql`
  mutation createOAuthProviderCode($clientID: String!) {
    createOAuthProviderCode(clientID: $clientID)
  }
`;
export default mutationCreateOAuthProviderCode;
